module.exports = __webpack_public_path__ + "img/retired-2013-xiayunling.7c2f4fb1.jpg";